import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "snackbar-container" }
const _hoisted_2 = { class: "snackbar-icon" }
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_4 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_5 = {
  key: 2,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_6 = {
  key: 3,
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_7 = { class: "snackbar-content" }
const _hoisted_8 = {
  key: 0,
  class: "snackbar-title"
}
const _hoisted_9 = { class: "snackbar-message" }
const _hoisted_10 = ["onClick"]

import { useSnackbar } from "../composables/useSnackbar";

export default /*@__PURE__*/_defineComponent({
  __name: 'AppSnackbar',
  setup(__props) {

const { snackbars, removeSnackbar } = useSnackbar();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "snackbar-list",
      tag: "div",
      class: "snackbar-wrapper"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(snackbars), (snackbar) => {
          return (_openBlock(), _createElementBlock("div", {
            key: snackbar.id,
            class: _normalizeClass(["snackbar", [`snackbar-${snackbar.type}`]])
          }, [
            _createElementVNode("div", _hoisted_2, [
              (snackbar.type === 'error')
                ? (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10"
                    }, null, -1),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "8",
                      x2: "12",
                      y2: "12"
                    }, null, -1),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "16",
                      x2: "12.01",
                      y2: "16"
                    }, null, -1)
                  ]))]))
                : (snackbar.type === 'success')
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("path", { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14" }, null, -1),
                      _createElementVNode("polyline", { points: "22 4 12 14.01 9 11.01" }, null, -1)
                    ]))]))
                  : (snackbar.type === 'warning')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[2] || (_cache[2] = [
                        _createElementVNode("path", { d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" }, null, -1),
                        _createElementVNode("line", {
                          x1: "12",
                          y1: "9",
                          x2: "12",
                          y2: "13"
                        }, null, -1),
                        _createElementVNode("line", {
                          x1: "12",
                          y1: "17",
                          x2: "12.01",
                          y2: "17"
                        }, null, -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("circle", {
                          cx: "12",
                          cy: "12",
                          r: "10"
                        }, null, -1),
                        _createElementVNode("line", {
                          x1: "12",
                          y1: "16",
                          x2: "12",
                          y2: "12"
                        }, null, -1),
                        _createElementVNode("line", {
                          x1: "12",
                          y1: "8",
                          x2: "12.01",
                          y2: "8"
                        }, null, -1)
                      ]))]))
            ]),
            _createElementVNode("div", _hoisted_7, [
              (snackbar.title)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(snackbar.title), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_9, _toDisplayString(snackbar.message), 1)
            ]),
            _createElementVNode("button", {
              class: "snackbar-close",
              onClick: ($event: any) => (_unref(removeSnackbar)(snackbar.id)),
              "aria-label": "Cerrar notificación"
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16",
                height: "16",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                _createElementVNode("line", {
                  x1: "18",
                  y1: "6",
                  x2: "6",
                  y2: "18"
                }),
                _createElementVNode("line", {
                  x1: "6",
                  y1: "6",
                  x2: "18",
                  y2: "18"
                })
              ], -1)
            ]))], 8, _hoisted_10)
          ], 2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})